import * as React from 'react';
import Layout from '../components/layout';

const Contacte = () => {
  return (
    <Layout title='Cos Paisatge, formulari de contacte' path='/contacte'>
      <div classNameName='contact'>
        <h2>Contacte</h2>
        <p>
          Pots posar-te en contacte amb nosaltres mitjançant aquest formulari:
        </p>
        <form
          name='contactForm'
          action='/gracies'
          method='POST'
          data-netlify='true'
        >
          <input type='hidden' name='form-name' value='contactForm' />
          <label className='label' htmlFor='email'>
            Email
          </label>
          <input name='email' className='input' type='email' id='input'></input>
          <label className='label' htmlFor='textarea'>
            Missatge
          </label>
          <textarea
            name='message'
            className='textarea'
            id='textarea'
          ></textarea>
          <button className='btn' type='submit'>
            👋 &nbsp; Enviar
          </button>
        </form>

        <div classNameName='contactDetails'>
          <p>També ens pots trobar a Instagram: </p>
          <h3>Eugeni Prieto</h3>
          <p>
            Instagram:{' '}
            <a
              className='contactLink'
              href='https://www.instagram.com/eugeniprieto'
            >
              @eugeniprieto
            </a>
          </p>
          <h3>Pau Guerrero</h3>
          <p>
            Instagram:{' '}
            <a
              className='contactLink'
              href='https://www.instagram.com/_pau_guerrero_'
            >
              @_pau_guerrero_
            </a>
          </p>
          <p>
            Pàgina web:{' '}
            <a className='contactLink' href='https://www.pauguerrero.cat'>
              www.pauguerrero.cat
            </a>
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Contacte;
